import { CancelToken } from 'axios';
import { awBridgeApi } from '../../Base';
import { AWProposalV2 } from '../../Models';

export interface ProposalWithSwitchesPayload {
  asOf: string;
  cancelToken?: CancelToken;
  configurationOverrides?: ConfigurationOverrides;
  pkg: string;
  proposal: AWProposalV2;
}

export interface ConfigurationOverrides {
  buySecurityReplacementOverride?: { enabled: boolean };
  calculateAndSweepCashOverride?: { enabled: boolean };
  configurationDirectory?: string;
  cusipBasedPairingOverride?: { enabled: boolean };
  italianFundSwitchingOverride?: { enabled: boolean };
}

export interface EnhanceProposalV3Response {
  proposal: AWProposalV2;
}
/**
 * Get back proposal enhanced with switches.
 */
export const V3_PROPOSALS_PATH = 'v3/proposals';
export async function postEnhanceProposalV3(payload: ProposalWithSwitchesPayload): Promise<EnhanceProposalV3Response> {
  const path = `${V3_PROPOSALS_PATH}/enhance`;

  const res = await awBridgeApi.post<EnhanceProposalV3Response>(path, payload, { params: { pkg: payload.pkg } });
  return res.data;
}
